import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequestProductSales } from "shared/utils/fetch-api";

export const fetchDictionaries = createAsyncThunk(
    'contract/fetchDictionaries',
    async ({
        agentSalesDataID,
        insuredBirthDate
    }: {
        agentSalesDataID: string;
        insuredBirthDate: string
    }, { rejectWithValue }) => {
        const requestBody = {
            "AgentSalesDataID": agentSalesDataID,
            "Source": "Site",
            "InsuredBirthDate": insuredBirthDate
        }
        try {
            const response = await getRequestProductSales(requestBody, 'product-sales', 'getDictionaries', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Programs: data.Programs,
                    Regions: data.Regions
                };
            } else {
                return data.Errors;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);


